<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Tourist tax' | translate }}</h4>
  </div>
  <div class="modal-body pb-0" id="report">
    <form class="row" novalidate [formGroup]="reportForm">
      <div class="col-auto">
        <div class="form-group mb-2">
          <select
            type="text"
            class="form-control"
            tabindex="0"
            id="propertyId"
            formControlName="propertyId"
          >
            <option [value]="property.id" *ngFor="let property of properties">
              {{ property.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-auto ml-auto">
        <div class="form-group">
          <select
            type="text"
            class="form-control"
            tabindex="0"
            id="year"
            formControlName="year"
          >
            <option [value]="year" *ngFor="let year of years">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-auto pl-0">
        <div class="form-group mb-2">
          <select
            type="text"
            class="form-control"
            tabindex="0"
            id="month"
            formControlName="month"
          >
            <option value="0">{{ 'All' | translate }}</option>
            <option [value]="month" *ngFor="let month of months">
              {{ month }}
            </option>
          </select>
        </div>
      </div>

      <hr class="w-100" />

      <div class="col-md-5 mb-3">
        <div class="row">
          <div class="col">
            {{ 'Nights' | translate }}:<br />
            {{ 'Guests' | translate }}:<br />
            {{ 'Full taxes' | translate }}:<br />
            {{ 'Half taxes' | translate }}:<br />
            {{ 'Exempt taxes' | translate }}:
          </div>

          <div class="col text-right">
            {{ numNights | number }}
            <br />

            {{ numGuests | pepNumber }}
            <br />

            {{ numFullTaxes | pepNumber }}
            <br />

            {{ numHalfTaxes | pepNumber }}
            <br />

            {{ numExemptTaxes | pepNumber }}
          </div>
        </div>
      </div>

      <div class="col offset-md-1 mb-3">
        <div class="row">
          <div class="col">
            <ng-container *ngFor="let ttaxValue of ttaxValues">
              {{ 'Full tax value' | translate }}:
              <br />
            </ng-container>
            <ng-container *ngFor="let ttaxHalfValue of ttaxHalfValues">
              {{ 'Half tax value' | translate }}: <br
            /></ng-container>
          </div>
          <div class="col-auto text-right">
            <ng-container *ngFor="let ttaxValue of ttaxValues">
              {{ ttaxValue | pepCurrency: currencyId:activeOrg.locale }}<br />
            </ng-container>
            <ng-container *ngFor="let ttaxHalfValue of ttaxHalfValues">
              {{ ttaxHalfValue | pepCurrency: currencyId:activeOrg.locale }}
              <br
            /></ng-container>
          </div>
        </div>

        <hr *ngIf="ttaxValues.length || ttaxHalfValues.length" />

        <div class="row">
          <div class="col">
            {{ 'Tourist tax' | translate }}:<br />
            {{ 'Promo tax' | translate }}:<br />
            <span class="h2 font-weight-bold mt-2 mb-0 d-block"
              >{{ 'Total' | translate }}:</span
            >
          </div>
          <div class="col-auto text-right">
            {{ ttaxTotal | pepCurrency: currencyId:activeOrg.locale }}
            <br />

            {{ promoTaxTotal | pepCurrency: currencyId:activeOrg.locale }}
            <br />
            <span class="h2 font-weight-bold mt-2 mb-0 d-block">
              {{ total | pepCurrency: currencyId:activeOrg.locale }}</span
            >
          </div>
        </div>
      </div>

      <div class="w-100"></div>

      <div class="col guestList border-top border-2">
        <table class="table mb-0">
          <tbody>
            <tr *ngFor="let guest of guests">
              <td class="col-auto text-nowrap">
                {{ guest.checkintime | pepDate: activeOrg.locale }}
              </td>
              <td class="col-auto text-nowrap">
                {{ guest.checkouttime | pepDate: activeOrg.locale }}
              </td>
              <td class="col">{{ guest.firstName }} {{ guest.lastName }}</td>
              <td class="text-right col-auto text-nowrap">
                <br />
                <span>{{ guest.stays }}</span
                ><br />
                <span>{{ guest.staysPromo }}</span>
              </td>
              <td class="text-right col-auto text-nowrap">
                <span class="font-weight-bold">{{
                  guest.total | pepCurrency: currencyId:activeOrg.locale
                }}</span
                ><br />
                <!--  -->
                <span>{{
                  guest.ttaxTotal | pepCurrency: currencyId:activeOrg.locale
                }}</span
                ><br />
                <!--  -->
                <span>{{
                  guest.promoTaxTotal | pepCurrency: currencyId:activeOrg.locale
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <!-- <button
      class="btn btn-outline-primary"
      type="button"
      (click)="onSend()"
    >
      <i class="fe fe-mail"></i> {{ 'Send' | translate }}
    </button> -->
    <button
      class="btn btn-outline-primary"
      type="button"
      (click)="onExportPdf()"
    >
      <i class="fe fe-file-text"></i> {{ 'Save as PDF' | translate }}
    </button>
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Close' | translate }}
    </button>
  </div>
</div>
